module.exports = __webpack_public_path__ + "static/Apercu-Medium-1a3b7c249968b04130ce0b554711789a.svg";